var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import * as Util from '../util'; // import { getMultiplicadorBaja } from './config-libro';

import { getConfigGeneral } from './index';

var getPaginas = function getPaginas(state, libroId) {
  var id = libroId; // || getId(state)

  return state.paginasLibros[id];
};

export var getEstaPaginaDefinida = function getEstaPaginaDefinida(state, libroId, numPagina) {
  var paginas = getPaginas(state, libroId);
  return typeof paginas[numPagina] !== 'undefined';
}; // const esZonaImg = zona => zona.boton.startsWith('img');
// const esZonaPoligonal = zona => zona.boton.includes(':');

export var getCaminoPagina = function getCaminoPagina(state, libroId, numPagina) {
  var paginas = getPaginas(state, libroId);

  if (!paginas[numPagina] || !paginas[numPagina].camino) {
    return false;
  }

  var infoCamino = paginas[numPagina].camino;
  var libroIdCamino = infoCamino.substring(0, 2);
  var numPaginaCamino = Number(infoCamino.substring(2));
  var hitos = getZonas(state, libroIdCamino, numPaginaCamino);
  var marcarBotonCamino = paginas[numPagina].marcarBotonCamino ? paginas[numPagina].marcarBotonCamino.split(',') : [];
  return {
    libroId: libroIdCamino,
    numPagina: numPaginaCamino,
    hitos: hitos,
    marcarBotonCamino: marcarBotonCamino
  };
};
export var getZona = function getZona(state, libroId, numPagina, numZona) {
  var zonas = getZonas(state, libroId, numPagina);
  return zonas[Number(numZona) - 1];
};

var vinculoPorDefecto = function vinculoPorDefecto(libroId, numPagina, zona) {
  return 'zoom,' + libroId + Util.pad3(numPagina) + ',' + zona.boton;
};

export var getZonas = function getZonas(state, libroId, numPagina) {
  var paginas = getPaginas(state, libroId);
  var numeroDePagina = Number(numPagina);
  var zonas = paginas[numeroDePagina] && paginas[numeroDePagina].ZONA || [];

  if (!Array.isArray(zonas)) {
    zonas = [zonas];
  }

  zonas = zonas.map(function (zona, index) {
    var zonaMultiplicada = _extends({
      numZona: index + 1
    }, zona); // vinculo por defecto si no tiene


    zonaMultiplicada.vinculo = zona.vinculo || vinculoPorDefecto(libroId, numeroDePagina, zona); // fix textos fijos botones ventana        
    // lee de configGeneral.botonesN2 los textos de los botones fijos
    // y si se trata de botones anulados (se usan como titulos) o no.

    var botonesN2 = getConfigGeneral(state).botonesN2;

    if (zonaMultiplicada.BOTON) {
      if (!Array.isArray(zonaMultiplicada.BOTON)) {
        zonaMultiplicada.BOTON = [zonaMultiplicada.BOTON];
      }

      zonaMultiplicada.BOTON = zonaMultiplicada.BOTON.map(function (BOTON) {
        var botonConfigurado = _extends({}, BOTON);

        var botonId = BOTON.id.split(',')[0];
        var configBOTON = botonesN2[botonId];

        if (configBOTON) {
          if (typeof configBOTON.texto !== 'undefined') {
            botonConfigurado.id = botonId + ',' + configBOTON.texto;
          }

          botonConfigurado.tipo = configBOTON.tipo || 'normal';
          botonConfigurado.anulado = configBOTON.anulado || false;
          botonConfigurado.multiLinea = configBOTON.multiLinea || false;
          botonConfigurado.clases = configBOTON.clases || false;
        } else {
          botonConfigurado.anulado = false;
        }

        return botonConfigurado;
      });
    }

    return zonaMultiplicada;
  });
  return zonas;
};